import { FunctionComponent } from 'react';
import { Modal } from '@property.com.au/ui-kit';
import { MediaGalleryModalContent } from './MediaGalleryModalContent';
import { IMediaGalleryModal } from '../../contexts/MediaGalleryModalContext/MediaGalleryModalContext';

export const mediaGalleryModalId = 'MediaGalleryModal';

export interface MediaGalleryModalProps {
  opened: boolean;
  onClose: () => void;
  initialImageIndex?: number;
  galleryItemKey?: string;
  openAction: IMediaGalleryModal['openAction'];
}

export const MediaGalleryModal: FunctionComponent<MediaGalleryModalProps> = ({
  opened,
  onClose,
  initialImageIndex,
  galleryItemKey,
  openAction,
}) => {
  return (
    <Modal
      opened={opened}
      getAppElement={() => '#argonaut-wrapper'}
      onRequestClose={onClose}
      reactModalProps={{
        id: mediaGalleryModalId,
        contentLabel: 'Media Gallery Modal',
        style: {
          overlay: {
            backgroundColor: 'rgba(38, 39, 43, 1)',
          },
          content: {
            padding: 0,
            width: '100%',
            height: '100%',
          },
        },
      }}
    >
      <MediaGalleryModalContent
        opened={opened}
        onClose={onClose}
        initialImageIndex={initialImageIndex}
        galleryItemKey={galleryItemKey}
        openAction={openAction}
      />
    </Modal>
  );
};
